import React, { useState, useEffect } from "react";
import { getDailyMealProgress, getMealplanByDate } from "../../../services/firebase/firestore/getData";
import "./Form.scss";
import Check from "./check.png";

export default function Form({ client_id, time }) {
    const [mealplan, setMealplan] = useState(false);
    const [totalEaten, setTotalEaten] = useState(false)
    let totalEatenCalories = 0;

    useEffect(() => {
        localStorage.removeItem("tabIndex")
        console.log("time in mealplan tab",time)
        debugger
        getMealplanByDate(client_id,time,(result)=>{
                console.log("result ",result)
                setMealplan(result);
                    result.plan && result.plan.map((item) => {
                        item.food && item.food.map((item) => {
                            if(item.completed) {
                                totalEatenCalories = parseInt(totalEatenCalories) + parseInt(item.calories);
                            }
                        })
                    })
                    setTotalEaten(totalEatenCalories);
        })
        // getDailyMealProgress(client_id, time, (result) => {
        //     debugger
        //     setMealplan(result);
        //     result.plan && result.plan.map((item) => {
        //         item.food && item.food.map((item) => {
        //             if(item.completed) {
        //                 totalEatenCalories = parseInt(totalEatenCalories) + parseInt(item.calories);
        //             }
        //         })
        //     })
        //     setTotalEaten(totalEatenCalories);
        // });
    }, [time, client_id]);
  
    return(
        <div className="c-mealplan-wrapper">
            <div className="c-mealplan-content">
                {mealplan.plan && mealplan.plan.map((item) => {
                    let eatenCalories = 0;
                    return  <div key={item.id + Math.random()*5000} className="c-mealplan-item-grid">
                                <h2 className="c-mealplan-title">{item.name}</h2>
                                {item.food && item.food.map((foodItem) => {
                                    if(foodItem.eaten) {
                                        eatenCalories = parseInt(eatenCalories) +  parseInt(foodItem.calories);
                                    }
                                })}
                                
                                <p className="c-mealplan-count">{eatenCalories} van {item.totalCaloriesAllowed}</p>
                                
                                {item.food && item.food.map((foodItem) => {
                                    return <>
                                            <div key={Math.random()*5000} className="c-mealplan-item">
                                                {/* <img className="c-mealplan-item--img" src={foodItem.completed? Check : "okkk"}/> */}
                                                <img className="c-mealplan-item--img" src={foodItem.name? Check : ""}/>
                                                <div>
                                                    <h3 className="c-mealplan-item--title">{foodItem.name}</h3>
                                                    <span className="c-mealplan-item--count">{foodItem.quantity}g - Fats : { Math.round(foodItem.fats*100)/100 } - Carbs : { Math.round(foodItem.carbs*100)/100 } - Alcohol : { Math.round(foodItem.alcohol*100)/100 } - Fiber : { Math.round(foodItem.fiber*100)/100 }</span>
                                                </div>
                                            </div>
                                            <p className="c-mealplan-item--kcal">{parseInt(foodItem.calories)} Kcal</p>
                                             </>
                                })}
                            </div>
                })}
                {mealplan.totalCaloriesAllowed? <p className="c-mealplan-final-count"><span>{totalEaten} kcal</span> from {mealplan.totalCaloriesAllowed}</p> : ""}
                {!mealplan? <p className="c-mealplan-empty">This client has no mealplan for this day yet.</p> : ""}
            </div>
        </div>
    );
}

